/**
 * Navigation constants for left navigation menu
 */

// Category types
export const CATEGORY_TYPES = {
    FAVORITES: "Favorites",
    HOME: "Home"
};

// Data attributes for DOM elements
export const DATA_ATTRIBUTES = {
    SERVICE_CARD: '[data-service-card]',
    NAV_CATEGORY: '[data-nav-category]',
    FAVORITE_BUTTON: '[data-favorite-button]',
    FLYOUT_MENU: '[data-flyout-menu]'
};

// Data attribute names (without brackets for getAttribute)
export const DATA_ATTRIBUTE_NAMES = {
    SERVICE_CARD: 'data-service-card',
    NAV_CATEGORY: 'data-nav-category',
    FAVORITE_BUTTON: 'data-favorite-button',
    FLYOUT_MENU: 'data-flyout-menu',
    NAV: 'data-nav'
};

// CSS class names
export const CSS_CLASSES = {
    SKIP_CONTENT: 'skip-content'
};

// Navigation indices base
export const NAVIGATION_INDEX = {
    START: 0,
    DISABLED: -1
};

// Translation keys
export const TRANSLATION_KEYS = {
    PRESS_TAB_KEY: "press_tab_key"
};

// Redux action types
export const MENU_ACTIONS = {
    SET_FAVOURITE: "MENU:SET-FAVOURITE",
    UNSET_FAVOURITE: "MENU:UNSET-FAVOURITE"
};

// DOM event types
export const DOM_EVENTS = {
    MOUSE_DOWN: 'mousedown',
    FOCUS_OUT: 'focusout'
};

// Navigation actions for keyboard navigation
export const NAVIGATION_ACTIONS = {
    VERTICAL: 'vertical',
    OPEN_CLOSE: 'open_close',
    ACTIVATE: 'activate',
    ESCAPE: 'escape',
    TAB_NAVIGATION: 'tab_navigation'
};

// Timing constants
export const TIMING_CONSTANTS = {
    FLYOUT_FOCUS_DELAY: 50 // Delay in milliseconds for flyout auto-focus
};

// Services that are in preview mode. Add service keys to this array to show "Preview" tag for them. Example: ["NetApp.BackupUbr"]
export const PREVIEW_SERVICES = [];